// import { Login } from "@mui/icons-material";
// import axiosInstance from "./axiosInstance";

// const staffService = {
//     create: async (payload) => {
//         try {
//             const response = await axiosInstance.post('/staff/create', payload);
//             return response.data;
//         } catch (error) {
//             throw error.response.data;
//         }
//     },
//     fetchAll: async () => {
//         try {
//             const response = await axiosInstance.get('/staff/all');
//             return response.data;
//         } catch (error) {
//             throw error.response.data;
//         }
//     },
//     fetchTotal: async () => {
//         try {
//             const response = await axiosInstance.get('/staff/total');
//             return response.data;
//         } catch (error) {
//             throw error.response.data;
//         }
//     },
//     fetchById: async (id) => {
//         try {
//             const response = await axiosInstance.get('/staff/id/' + id);
//             return response.data;
//         } catch (error) {
//             throw error.response.data;
//         }
//     },
//     update: async (id, payload) => {
//         try {
//             const response = await axiosInstance.put(`/staff/edit/${id}`, payload);
//             return response.data;
//         } catch (error) {
//             throw error.response.data;
//         }
//     },

// };

// export default staffService;

import axiosInstance from "./axiosInstance";

const staffService = {
    create: async (payload) => {
        try {
            const response = await axiosInstance.post('/staff/create', payload);
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },
    fetchAll: async () => {
        try {
            const response = await axiosInstance.get('/staff/all');
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },
    fetchTotal: async () => {
        try {
            const response = await axiosInstance.get('/staff/total');
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },
    fetchById: async (id) => {
        try {
            // Backend route is `router.get("/:id", ...)`, not `/id/:id`
            const response = await axiosInstance.get(`/staff/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },
    update: async (id, payload) => {
        try {
            // Backend route is `router.put("/update", ...)` and reads
            // staff_id from the body — not from a URL param.
            const response = await axiosInstance.put(`/staff/update`, {
                ...payload,
                staff_id: id,
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

};

export default staffService;
